import React from 'react'
import useLocalStorage from '../../hooks/useLocalStorage'
import { noProfile, ProfileContext } from '../../context/ProfileContext'
import AppBar from '../AppBar'
import MatchMakerContainer from '../../containers/MatchMaker'
import './styles.css'

function App() {
    const [profile, setProfile] = useLocalStorage('profile')
    let _profile = profile ? profile : noProfile

    return (
        <ProfileContext.Provider value={{ profile: _profile, setProfile }}>
            <div className="App">
                <header className="App-header">
                    <AppBar />
                </header>
                <main className="App-main">
                    <MatchMakerContainer />
                </main>
            </div>
        </ProfileContext.Provider>
    )
}

export default App
